import { MDBBtn, MDBCol, MDBRow } from "mdb-react-ui-kit";
import React, { useEffect, useState } from "react";

function Multiple(props) {
  const [sketchfabApi, setSketchfabApi] = useState();
  const [sketchfabApi2, setSketchfabApi2] = useState();
  const [incorrectHeader, setIncorrectHeader] = useState(
    props?.currentData?.assetIds[3]?.name
  );

  const [compareAssetId, setCompareAssetId] = useState(
    props.currentData.assetIds[3].id
  );

  const [correctAssetId, setCorrectAssetId] = useState(
    props.currentData.assetIds[0].id
  );

  const changeCompareId = (evt, id, headerName) => {
    setCompareAssetId(id);
    SetActive(evt);
    setIncorrectHeader(headerName);
  };

  /**
   * Active Status for Swatches
   */
  const SetActive = (event) => {
    // find the swatches collection you want to apply this function too
    var tempName = event.target.name;
    var elements = document.getElementsByName(tempName);

    // remove all the active status
    for (var i = 0; i < elements.length; i++) {
      elements[i].classList.remove("swatch-active");
    }

    // add the status on the one that is clicked!!
    event.target.classList.add("swatch-active");
  };

  useEffect(() => {
    if (props) {
      /**
       *
       * Get the Sketchfab Player API
       */
      var iframe = document.getElementById("api-frame1");
      var iframe2 = document.getElementById("api-frame2");
      var version = "1.12.1";
      var client = new window.Sketchfab(version, iframe);
      var client2 = new window.Sketchfab(version, iframe2);
      var apiOne, apiTwo;

      var duration;

      var animationsList;
      var current_anim;

      // assetId/uid of the model to be displayed

      // var uid = "5cac24da41de4a848bca43ea30e3fad7";
      var uid = correctAssetId;
      // var uid2 = "f85404601bae41cda6d39d2173ccacc2";
      var uid2 = compareAssetId;

      /**
       * Separate on Success Function so most of the work can be done here
       */
      var success = (api) => {
        setSketchfabApi(api);
        apiOne = api;
        api.start();
        api.addEventListener("viewerready", function () {
        });
      };

      var success2 = (api2) => {
        apiTwo = api2;
        setSketchfabApi2(api2);
        api2.start();
        api2.addEventListener("viewerready", function () {
          api2.addEventListener("camerastop", function () {
            api2.getCameraLookAt(function (err, camera) {
              window.console.log(camera.position); // [x, y, z]
              window.console.log(camera.target); // [x, y, z]
              if (apiOne) {
                apiOne.setCameraLookAt(camera.position, camera.target, 2);
              }
            });
            window.console.log("Camera stopped");
          });
        });
      };

      // Initialization of the view with the uid above
      client.init(uid, {
        success,
        error: function onError() {
          // console.log("Viewer error");
        },
        autostart: 1,
        preload: 0,
        ui_watermark: 0,
        ui_settings: 0,
        ui_inspector: 0,
        ui_infos: 0,
        ui_fullscreen: 0,
        ui_controls: 1,
        ui_stop: 0,
        ui_ar: 1,
        ui_animations: 0,
        ui_annotations: 0,
        ui_ar_help: 0,
      });
      // Initialization of the view with the uid above
      client2.init(uid2, {
        success: success2,
        error: function onError() {
          // console.log("Viewer error");
        },
        autostart: 1,
        preload: 0,
        ui_watermark: 0,
        ui_settings: 0,
        ui_inspector: 0,
        ui_infos: 0,
        ui_fullscreen: 0,
        ui_controls: 1,
        ui_stop: 0,
        ui_ar: 1,
        ui_animations: 0,
        ui_annotations: 0,
      });
    }
  }, [compareAssetId, correctAssetId, props]);
  return (
    <>
      <MDBRow className="sidebyside-plugin-class">

          <MDBCol md="5" lg="5" className="side-side-full">
				<MDBRow md="5">
					<p className="p-0 m-0" style={{ color: "green", textAlign: "center", fontWeight: "bold"}}>
					{props?.currentData?.assetIds[0]?.name}
					</p>
				</MDBRow>
				<MDBRow>
				
					<iframe
						title="Paracosma"
						src=""
						id="api-frame1"
						allowFullScreen
						mozallowfullscreen="true"
						webkitallowfullscreen="true"
						style={{
						// position: "absolute",
						width: "100%",
						height: "400px",
						margin: 0,
						padding: "10px",
						backgroundColor: "green",
						overflow: "hidden",
						zIndex: 9999,
						}}
					></iframe>
				</MDBRow>
          </MDBCol>
          <MDBCol md="5" lg="5" className="side-side-full">
			<MDBRow md="5">
				<p className="p-0 m-0" style={{ color: "red", textAlign: "center", fontWeight: "bold"}}>
				{incorrectHeader}
				</p>
			</MDBRow>
            <MDBRow>
				<iframe
				title="Paracosma"
				src=""
				id="api-frame2"
				allowFullScreen
				mozallowfullscreen="true"
				webkitallowfullscreen="true"
				style={{
					// position: "absolute",
					width: "100%",
					height: "400px",
					margin: 0,
					padding: "10px",
					backgroundColor: "red",
					overflow: "hidden",
					zIndex: 9999,
				}}
				></iframe>
            </MDBRow>
          </MDBCol>
          <MDBCol md="2" lg="2" >
            <div className="d-flex justify-content-center mt-4 flex-column">
              {props.currentData.assetIds.map((el, index) =>
                index !== 0 ? (
                  <MDBBtn
                    key={index}
                    outline
                    name="compareOptions"
                    color="dark"
                    className={
                      index === 3 ? "p-2 my-2 btn-sidebyside swatch-active" : "  btn-sidebyside  p-2 my-2"
                    }
                    onClick={(evt) => changeCompareId(evt, el.id, el.name)}
                  >
                    {el.name}
                  </MDBBtn>
                ) : null
              )}
              <p className="warning-sidebyside">
              Explore the full experience by moving the model on the RED CANVAS 
              </p>
            </div>
          </MDBCol>
      </MDBRow>
    </>
  );
}

export default Multiple;
